import React, { useContext } from 'react';
import styled from 'styled-components';
import MainContext from '../../MainContext';
import { ThemeContext } from 'context/themeContext';
import ToasterComponent from './toaster-component';

const StyledIcon = styled.div`
  width: 3.489vw;
  height: 3.489vw;
  margin-left: 1.56vw;
  margin-right: 1.04vw;
  position: relative;

  align-items: center;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.icons};
  font-size: 3.5vw;
`;

const Wrapper = styled.div`
  position: fixed;
  top: 4.01vw;
  left: ${(props) => (props.rtlDirection ? '2.0416vw' : 'unset')};
  right: ${(props) => (props.rtlDirection ? 'unset' : '2.0416vw')};
  width: 25.52vw;
  z-index: 100000;
`;

const ToasterBox = (props) => {
  const { toasterMessages, setToasterContext } = useContext(MainContext).toasters;
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { blueColorPrimary, redColor, greenColor, yellowColor } = theme;

  let content = [];
  toasterMessages.map((toasterMessage, index) => {
    const toasterType =
      toasterMessage.type === 'error'
        ? { backgroundColor: redColor, icon: <StyledIcon className="icon-error" theme={theme} /> }
        : toasterMessage.type === 'info'
        ? {
            backgroundColor: blueColorPrimary,
            icon: <StyledIcon className="icon-info" theme={theme} />,
          }
        : toasterMessage.type === 'success'
        ? {
            backgroundColor: greenColor,
            icon: <StyledIcon className="icon-success" theme={theme} />,
          }
          : toasterMessage.type === 'upgrade' //added for upgrade toaster 
        ? { 
            backgroundColor: blueColorPrimary,
            icon: <StyledIcon className="icon-info" theme={theme} />,
          }
          : toasterMessage.type === 'upgrade' //added for upgrade toaster 
        ? { 
            backgroundColor: blueColorPrimary,
            icon: <StyledIcon className="icon-info" theme={theme} />,
          }
        : {
            backgroundColor: yellowColor,
            icon: <StyledIcon className="icon-warnning" theme={theme} />,
          };
    const messageLines = toasterMessage.message.split('<br>');
    content.push(
      <ToasterComponent
        backgroundColor={toasterType.backgroundColor}
        toastIndex={index}
        key={toasterMessage.key}
        isUpgrade={toasterMessage.type}
        family= {toasterMessage.family}
        phoneNumber={toasterMessage.phoneNumber}
      >
        {toasterType.icon}
        <div style={{ position: 'relative', width: '15.3vw' }}>
          {messageLines.map((text, i) => (
            <React.Fragment key={i}>
              {text}
              {i !== messageLines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      </ToasterComponent>
    );
  });
  return (
    <Wrapper
      theme={theme}
      rtlDirection={rtlDirection}
      selected={props.selected}
      onClick={props.onClick}
    >
      {content}
    </Wrapper>
  );
};

export default ToasterBox;
